/**
 * 기압 단위 변환 함수: inHg (인치 수은주) -> hPa (헥토파스칼)
 * 1 inHg ≈ 33.863886666667 hPa
 * @param {number|string} inHg - inHg 기압값
 * @param {number|null} [decimals=0] - 소수점 자리수 (기본값: 0, 정수로 변환. null 지정 시 반올림 없이 전체 소수점 반환)
 * @returns {number|null} hPa 기압값 (입력이 유효하지 않은 경우 null)
 */
export const convertToHpa = (inHg, decimals = 0) => {
  if (inHg === null || inHg === undefined || inHg === "") {
    return null;
  }

  const num = parseFloat(inHg);
  if (isNaN(num)) {
    return null;
  }

  const hpa = num * 33.863886666667;

  if (decimals !== null && decimals >= 0) {
    const factor = Math.pow(10, decimals);
    return Math.round(hpa * factor) / factor;
  }

  return Math.round(hpa);
};

export default convertToHpa;
